var path = '/ssd/jenkins/workspace/Unmanaged/Release_arcade-ui/app/views/ui/skip-to-main.html';
var html = "<button id=\"skip-to-main\"\n        class=\"inverse-btn\"\n        ng-click=\"$skipCtrl.focusOnMainContent()\"\n        translate=\"SKIP_TO_MAIN_CONTENT\">\n</button>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;